import { createStore } from '@souche-f2e/muji';
import setting from '../setting';
const state = Object.assign({}, setting);
export default createStore({
    state,
});
